import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { checklistSectionEditModelToOutDto } from 'shared/domain/checklistSection/mapping/toDto';
import { ChecklistSectionEditModel } from 'shared/domain/checklistSection/types/model';
import { EditChecklistSectionUseCase } from 'shared/domain/checklistSection/types/useCases';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistSectionHttpEditRequestModel } from '../httpQueue/checklistSection/types';

export class ChecklistSectionEditor implements EditChecklistSectionUseCase {
  constructor(
    private addRequest: (
      request: ChecklistSectionHttpEditRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    editModel: ChecklistSectionEditModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('EditChecklistSectionUseCase', editModel);

    const checklistSectionUpdateOutDto =
      checklistSectionEditModelToOutDto(editModel);
    const url = `/project/${editModel.projectId}/inspectionTemplate/${editModel.inspectionTemplateId}/section/${editModel._id}`;

    const request: ChecklistSectionHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        checklistSectionUpdateOutDto,
        sectionId: editModel._id,
        projectId: editModel.projectId,
        inspectionTemplateId: editModel.inspectionTemplateId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistSection,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistSectionEditor = new ChecklistSectionEditor(addRequest);
